import { createFileRoute } from '@tanstack/react-router';
import { Stack, Title, Text } from '@mantine/core';

function Privacy() {
  return (
    <Stack gap="md">
      <Title order={2}>Privacy Policy</Title>
      <Text>
        LeadSync is a multi-tenant marketing platform that connects to your Meta Business account
        (WhatsApp / Facebook / Instagram) on your behalf. We process and store the minimum data
        required to deliver your campaigns, render your inbox, and audit changes.
      </Text>
      <Text fw={600}>Data we store</Text>
      <Text>
        Account profile (name, email, language, timezone), your contacts (name, phone / WhatsApp ID,
        opt-out flags), message history (inbound and outbound bodies, media metadata, timestamps),
        and audit-trail entries for every state-mutating action.
      </Text>
      <Text fw={600}>Data we do not store</Text>
      <Text>
        Plain-text Meta access tokens — every long-lived token is encrypted at rest with AES-256-GCM
        under a key managed by your cloud KMS. We never log token values.
      </Text>
      <Text fw={600}>Data deletion</Text>
      <Text>
        See <a href="/legal/data-deletion">our data-deletion process</a>. When Meta sends us a
        deletion request on your behalf, we hard-delete every row keyed to your Facebook user id and
        respond to Meta with a public confirmation URL.
      </Text>
    </Stack>
  );
}

export const Route = createFileRoute('/legal/privacy')({ component: Privacy });
